var RACheck = React.createClass({
  propTypes: {
    isChecked: React.PropTypes.bool.isRequired,
    label: React.PropTypes.string,
    value: React.PropTypes.any.isRequired,
    onClick: React.PropTypes.func.isRequired
  },
  checkClicked() {
    this.props.onClick(this.props.value);
  },

  render() {
    let checkClass = "ra-check" + (this.props.isChecked ? " checked" : "");
	let ariaChecked = (this.props.isChecked ? true : false);

    return (
      <div className={checkClass} role="checkbox" onClick={this.checkClicked} aria-checked={ariaChecked} tabIndex="0" aria-label="Solution filter option">
        <span className="ra-check__box"></span><a href="#" tabIndex="-1" className="ra-check__label">{this.props.label}</a>
      </div>
    )
  }
});